import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from '@xstyled/styled-components';
import { styleVariables } from '../../style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLoadingPage = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n"])));
var StyledTitle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: 12px;\n  font-size: ", ";\n  font-weight: 500;\n"])), function (props) {
  return props.size === 'large' ? '25px' : '20px';
});
var StyledLoading = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  span {\n    height: ", ";\n    width: ", ";\n    margin: 0 5px;\n    background-color: ", ";\n    border-radius: 50%;\n    display: inline-block;\n    animation-name: dots;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    animation-timing-function: ease-in-out;\n    &:nth-child(2) {\n      animation-delay: 0.4s;\n    }\n    &:nth-child(3) {\n      animation-delay: 0.8s;\n    }\n  }\n  @keyframes dots {\n    50% {\n      transform: scale(0.7) translateY(10px);\n    }\n  }\n"])), function (props) {
  return props.size === 'large' ? '25px' : '20px';
}, function (props) {
  return props.size === 'large' ? '25px' : '20px';
}, styleVariables.colors.primary60);
export var LoadingPage = function LoadingPage(_ref) {
  var title = _ref.title,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size;
  return /*#__PURE__*/_jsxs(StyledLoadingPage, {
    role: "status",
    "aria-live": "polite",
    "aria-label": title || 'Loading page',
    children: [/*#__PURE__*/_jsxs(StyledLoading, {
      size: size,
      children: [/*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx("span", {})]
    }), /*#__PURE__*/_jsx(StyledTitle, {
      size: size,
      children: title || 'Loading...'
    })]
  });
};